




















































































/* 
  saveOrUpdate 保存或编辑教师信息
*/
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Form as ElForm } from "element-ui";
import { validateMax32, validateAge,validateTeacherAge, blurTeacherAge, ruleNormal, rulePattern,validatePhone } from '@/utils/regxCustom'
import {
  saveOrUpdate,
  getTeacherInfoByCardId,
   addProjectMaterialInfo
} from "../../../../api/projectMaterial";
import {
  computedDate
} from "../../../../utils/common";
import {getToken} from "@/utils/auth";

@Component({
  name: "projectMaterialManageDetail"
})
export default class extends Vue {
  @Prop(String) type!: string;
  @Prop(Object) private projectMaterialInfo!: {
    materialProjectId: "";
    materialPath: "";
    materialContent: "";
    materialTitle: "";
    materialId: "";
  };

  private fullscreenLoading: boolean = false; //spin toggle

  private editForm: Object = {
    materialProjectId: this.$parent['projectId'] || this.projectMaterialInfo.materialProjectId || "",
    materialPath: this.projectMaterialInfo.materialPath || "",
    materialContent: this.projectMaterialInfo.materialContent || "",
    materialTitle: this.projectMaterialInfo.materialTitle || "",
    materialId: this.projectMaterialInfo.materialId || ""
  };

  private dialogFormTitle: string = ""; //弹窗标题
  private fileTitle: string = ""; //文件名
  private editFormRules: object = {
    materialProjectId: [ruleNormal("请选择项目")],
    materialTitle: [ruleNormal("请输入标题")],

    materialContent: [ruleNormal("请填写内容")]

  };

  created() {
    if (this.type === "add") {
      this.dialogFormTitle = "添加项目材料";
    } else if (this.type === "modify") {
      this.dialogFormTitle = "修改项目材料";
    }

  }
  private upload = {
    header: {
      Authorization: getToken(),
      access_token: getToken()
    },
    fileList: []
  };
//上传地址
  get uploadUrl() {
    return (
        window.config.baseUrl4Shool + "/baseinfo/projectMaterial/upLoadHeadPdf"
    );
  }

  private handleAvatarSuccess(res: any) {
    try {
      if (res.code != "20000000") {
        // this.$message.error(res.mesg);
        this[`$message`]({
          type: "error",
          message: res!.mesg ? res!.mesg : res
        });
      }
      console.log("res.data=",res.data);
      this.editForm[`materialPath`] =  res.data;
       // this.editForm.materialPath = res.data;
      // this.imageUrl =
      //     window.config.baseUrl4Shool + this.teacherInfoVo.teacherPhotoPath;
      this.$forceUpdate();
    } catch (error) {
      // this.$message.error(error || "上传失败！");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  private beforeAvatarUpload(file: any) {
    console.log("11111",file.name );
    const isPDF = file.type === "application/pdf";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isPDF) {
      this.$message.error("上传附件只能是 PDF 格式!");
    }
    if (!isLt2M) {
      this.$message.error("上传附件大小不能超过 2MB!");
    }
    this.fileTitle = file.name;
    this.$forceUpdate();
    return isPDF && isLt2M;
  }
  // 根据是否推荐显示value，但是传给后台传递数字
  private ifRecommend(e) {
    if (e !== "") {
      this.editForm[`otherinfoIsRecommendValue`] = e == "0" ? "是" : "否";
    } else {
      this.editForm[`otherinfoIsRecommendValue`] = null;
    }
    this.editForm[`otherinfoIsRecommend`] = e;
  }
  // @Watch("teacherInfo", { deep: true })
  // private getTeacherInfo(val) {
  //   if (this.type === "modify") {
  //     this.editForm = val;
  //   }
  // }
  // form 表单正则之外的校验 res = {age:'', bornDate:'',gender:''} 1 男 2 女




  // 保存或编辑
  private saveEditHandle() {
    (this.$refs.editForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        //清除undefined字符串
        for(let key in this.editForm) {
          if(typeof this.editForm[key] == 'string' && 
          this.editForm[key] == 'undefined'
          && key !== 'teacherName') {
            this.editForm[key] = ''
          }
        }
        try {
          this.fullscreenLoading = true;
          let res =
            this.type === "modify"
              ? await saveOrUpdate(this.editForm)
              : await addProjectMaterialInfo(this.editForm);
          this.fullscreenLoading = false;
          this.$message.success("保存成功");
          //关闭弹窗
          (this.$parent as any).dialogFormVisible = false;
          //刷新列表
          (this.$parent as any).getData();
          (this.$refs.editForm as ElForm).clearValidate();
        } catch (error) {
          this.fullscreenLoading = false;
          // this.$message.error(error || "保存失败");
          this[`$message`]({
            type: "error",
            message: error!.mesg ? error!.mesg : error
          });
        }
      }
    });
  }

  // 取消
  private handleCancel() {
    (this.$refs.editForm as ElForm).clearValidate();
    (this.$parent as any).dialogFormVisible = false;
  }
}
